import React from "react";
import classnames from "classnames";

// import './TruncatedTextBox.scss';

const TruncatedTextBox = ({
  children,
  lines,
  className,
  lineHeight,
  minHeight
}) => {
  const height = `${lineHeight * lines}em`;
  const textStyle = {
    WebkitLineClamp: lines,
    maxHeight: height,
    lineHeight
  };
  if (minHeight) {
    textStyle.minHeight = height;
  }
  return (
    <div
      className={classnames("TruncatedTextBox", className)}
      // style={textStyle}
    >
      {children}
    </div>
  );
};

TruncatedTextBox.defaultProps = {
  lines: 1,
  lineHeight: 1.3,
  minHeight: true
};

export default TruncatedTextBox;



// WEBPACK FOOTER //
// ./src/components/TruncatedTextBox.js